module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "index_oo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box3 cpoint"
  }, [_c('div', {
    staticClass: "box3_right",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "box3_center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "placeholder": "请输入您要搜索的关键词"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.searchEnterFun($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box3_sou",
    on: {
      "click": _vm.tosearch
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._v("搜索")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box55 cpoint"
  }, [_c('div', {
    staticClass: "box2"
  }, [_c('div', {
    staticClass: "box2_center",
    staticStyle: {
      "min-height": "545px"
    }
  }, [_c('table', {
    staticClass: "bo",
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', {
    staticClass: "bo_cc",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), (_vm.systeminfo.system_type == 2 || _vm.systeminfo.system_type == 3) ? _c('td', {
    staticStyle: {
      "width": "260px"
    }
  }, [_vm._v("公司名称")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "260px"
    }
  }, [_vm._v("政策名称")]), _vm._v(" "), _c('td', [_vm._v("开始时间")]), _vm._v(" "), _c('td', [_vm._v("截止时间")]), _vm._v(" "), _c('td', [_vm._v("查看详情")]), _vm._v(" "), _c('td', [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "trcla"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.systeminfo.system_type == 2 || _vm.systeminfo.system_type == 3) ? _c('td', {
      staticStyle: {
        "width": "260px"
      }
    }, [_vm._v(_vm._s(item.company_name))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "260px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.end_time))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "flex justify-around align-center",
      staticStyle: {
        "color": "#6491ff"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.outweb(item.link)
        }
      }
    }, [_vm._v("政策详情")])])]), _vm._v(" "), _c('td', {
      staticClass: "box2_tt flex justify-around align-center"
    }, [_c('div', {
      staticClass: "flex justify-around align-center",
      staticStyle: {
        "width": "75%"
      }
    }, [_c('el-popconfirm', {
      attrs: {
        "title": "确定跟进？"
      },
      on: {
        "confirm": function($event) {
          return _vm.tofollow(item.id, item.company_id)
        }
      }
    }, [_c('el-button', {
      staticStyle: {
        "border": "1px solid #6491ff",
        "border-radius": "15px !important",
        "color": "#6491ff",
        "padding": "0 20px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("跟进")])], 1), _vm._v(" "), _c('el-popconfirm', {
      attrs: {
        "title": "确定删除吗？"
      },
      on: {
        "confirm": function($event) {
          return _vm.todelete(item.id, item.company_id, index)
        }
      }
    }, [_c('el-button', {
      staticStyle: {
        "border": "1px solid #6491ff",
        "border-radius": "15px !important",
        "color": "#6491ff",
        "padding": "0 20px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("删除")])], 1)], 1)])])
  })], 2), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.emptyedit
    }
  }, [(!_vm.list.length) ? _c('nomore') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "response text-center padding-tb"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "预警详情",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.cominfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.company_name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "company_name", $$v)
      },
      expression: "cominfo.company_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人姓名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "name", $$v)
      },
      expression: "cominfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "phone", $$v)
      },
      expression: "cominfo.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房屋信息",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.office),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "office", $$v)
      },
      expression: "cominfo.office"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入驻时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.cominfo.start_time),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "start_time", $$v)
      },
      expression: "cominfo.start_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "费用到期时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.cominfo.end_time),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "end_time", $$v)
      },
      expression: "cominfo.end_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实付总数",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.real_pay),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "real_pay", $$v)
      },
      expression: "cominfo.real_pay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "押金",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.yajin),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "yajin", $$v)
      },
      expression: "cominfo.yajin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同序号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.number),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "number", $$v)
      },
      expression: "cominfo.number"
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index1_until cpoint"
  }, [_c('div', {
    staticClass: "index1_until_shu"
  }), _vm._v(" "), _c('div', {
    staticClass: "index1_until_text"
  }, [_vm._v("政策通知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box3_tu"
  }, [_c('img', {
    staticStyle: {
      "width": "25px",
      "height": "25px"
    },
    attrs: {
      "src": "/static/assets/images/sou.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4d623bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/systemitem/account.vue
// module id = 415
// module chunks = 1